import * as React from 'react';
export const eyeOpenSvg = React.forwardRef(function eyeOpenSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6 3.6a2.4 2.4 0 1 1-.001 4.8A2.4 2.4 0 0 1 6 3.6ZM6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6 1.219c3 0 6 2.574 6 4.781l-.009.208C11.812 8.365 8.906 10.781 6 10.781l-.281-.008C2.909 10.625.182 8.296.009 6.208L0 6c0-2.207 3-4.781 6-4.781Zm0 1.4c-1.118 0-2.314.491-3.24 1.247C1.798 4.654 1.4 5.491 1.4 6c0 .509.397 1.346 1.36 2.134C3.687 8.89 4.883 9.38 6 9.38c1.118 0 2.314-.491 3.24-1.247.963-.788 1.36-1.625 1.36-2.134 0-.509-.397-1.346-1.36-2.134C8.313 3.11 7.117 2.62 6 2.62Z',
    }),
  );
});
eyeOpenSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var eyeOpen = {
  category: 'icon',
  colorable: true,
  name: 'eyeOpen',
  svg: eyeOpenSvg,
};
